const ENPanelOccurrences = {
	"A data final da etapa deve ser maior do que a data da própria ocorrência": "The end date of the step must be greater than the date of the occurrence",
	"A data inicial da etapa deve ser maior do que a data da própria ocorrência": "The start date of the step must be greater than the date of the occurrence",
	"A ocorrência não pode ser salva pois já se encontra concluída ou cancelada": "The occurrence cannot be saved as it is already completed or canceled",
	"Abrir link externo": "Open external link",
	"Aceitar": "Accept",
	"Alterar Ocorrência": "Change Occurrence",
	"Analisar": "Analyze",
	"Análises críticas (FCA)": "Critical Analysis (FCA)",
	"Após a ocorrência deixar de ser nova ela não pode mais retornar para essa situação":"After the occurrence is no longer new, it can no longer return to this situation",
	"Aprovada": "Approved",
	"As datas finais das etapas devem ser maiores do que as datas iniciais":"Step end dates must be greater than the start dates",
	"As datas iniciais das etapas devem ser maiores que a da ocorrência": "The start dates of the steps must be greater than the occurrence",
	"As datas iniciais e finais das etapas devem ser maiores do que a data da própria ocorrência":"The start and end dates of the steps must be greater than the date of the occurrence",
	"atrasado": "late",
	"atrasados": "late",
	"Autoridade é requerido": "Authority is required",
	"Associar Link": "Associate Link",
	"Ações Imediatas": "Immediate actions",
	"Adicionar Ocorrência": "Add Occurrence",
	"Categoria é requerido": "Category is required",
	"Categoria": "Category",
	"Código está incorreto": "Code is incorrect",
	"Código Interno": "Internal code",
	"Copiar Ocorrência": "Copy Occurrence",
	"Concluída": "Completed",
	"Data e hora": "Date and time",
	"Data inicial": "Initial date",
	"Deseja realmente excluir a ocorrência": "Do you really want to delete the occurrence",
	"Digite o título da ocorrência para excluí-lo": "Enter the title of the issue to delete it.",
	"Erro ao adicionar ocorrência": "Error adding occurrence",
	"Erro ao alterar ocorrência": "Error changing occurrence",
	"Erro ao atualizar ocorrência, favor atualizar a pagina": "Error updating occurrence, please update page",
	"Erro ao carregar a ocorrência": "Error loading occurrence",
	"Erro ao carregar as etapas de ocorrência": "Error loading occurrence steps",
	"Erro ao carregar o risco": "Error loading risk",
	"Erro ao carregar ocorrência": "Error loading occurrence",
	"Erro ao carregar os ocorrência": "Error loading occurrences",
	"Erro ao excluir ocorrência": "Error deleting occurrence",
	"Erro ao registrar histórico de ocorrência": "Error recording occurrence history",
	"Essa ocorrência necessita Análise FCA para ser finalizada": "This occurrence requires FCA Analysis to be completed",
	"Esta ocorrência não possui nenhum link associado": "This occurrence does not have any associated links",
	"Etapa atual": "Current stage",
	"Executar": "Execute",
	"Exclusão de Ocorrência": "Delete Occurrence",
	"Finalizada": "Finished",
	"Gravidade": "Gravity",
	"Histórico de ocorrência": "Occurrence history",
	"Histórico": "Historic",
	"Link é requerido": "Link is required",
	"Link externo": "External link",
	"Minhas ocorrências": "My occurrences",
	"não iniciado": "not started",
	"não iniciados": "not started",
	"Nenhuma etapa foi encontrada, verifique se existe alguma categoria de ocorrência selecionada": "No steps were found, check if there is any occurrence category selected",
	"Nova ocorrência": "New occurrence",
	"Ocorrência adicionada com sucesso": "Occurrence successfully added",
	"Ocorrência alterada com sucesso": "Occurrence successfully changed",
	"Ocorrência copiada com sucesso": "Occurrence successfully copied",
	"Ocorrência excluída com sucesso": "Occurrence successfully deleted",
	"Ocorrência": "Occurrence",
	"Operador é requerido": "Operator is required",
	"Operador": "Operator",
	"Origem é requerido": "Origin is required",
	"Origem": "Source",
	"Painel de Ocorrências": "Occurrences Panel",
	"Painel de ocorrências": "Occurrences panel",
	"Para finalizar a ocorrência, é necessário que todas as ações estejam concluídas/canceladas": "To end the occurrence, all actions must be completed/cancelled",
	"Prioridade (Calculada)": "Priority (Calculated)",
	"Prioridade": "Priority",
	"Registrar histórico": "Record history",
	"Registro de histórico de ocorrência inserido com sucesso": "Occurrence history record successfully inserted",
	"Registro de Histórico": "History Record",
	"Registro": "Record",
	"Reincidente": "Recidivism",
	"Remover link": "Remove link",
	"Reprovada": "Disapproved",
	"Reprovado": "Disapproved",
	"reprovado": "disapproved",
	"reprovados": "disapproved",
	"reprovadas": "disapproved",
	"reprovada": "disapproved",
	"Requisito é requerido": "Requirement is required",
	"Requisito": "Requirement",
	"Responsável é requerido": "Responsible is required",
	"Responsável etapa": "Responsible step",
	"Setor é requerido": "Sector is required",
	"Status": "Status",
	"Tendência": "Tendency",
	"Titulo da ocorrência não confere": "Occurrence title does not match",
	"Todas as ocorrências": "All occurrences",
	"Urgência": "Urgency",
	"Verificar Eficácia": "Check Effectiveness",
	"Verificar": "Verify",
	"Visualizar Ocorrência": "View Occurrence"
};

export default ENPanelOccurrences;
